import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { setMeta } from "@/lib/museo";
import { Footer } from "@/components/Footer";

export const LegalLayout = ({ title, metaTitle, children }) => {
  useEffect(() => {
    setMeta({
      title: metaTitle || `${title} — Il Museo delle Promesse`,
      canonical: `${window.location.origin}${window.location.pathname}`,
      ogType: "website",
    });
  }, [title, metaTitle]);

  return (
    <div className="relative z-10 min-h-screen flex flex-col">
      <div className="flex-1 max-w-3xl mx-auto px-6 md:px-12 pt-16 md:pt-24 w-full">
        <Link
          to="/"
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 text-sm text-museo-muted hover:text-museo-accent transition-colors mb-12 uppercase tracking-[0.15em]"
        >
          <ArrowLeft className="w-4 h-4" /> Torna al museo
        </Link>
        <h1 className="font-serif text-4xl md:text-5xl text-museo-text mb-10">{title}</h1>
        <div className="text-museo-muted font-light leading-relaxed space-y-5 text-base">
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};
